import TrackingUtils from '../../../assets/components/fsUtils/TrackingUtils';
import {shareLinks} from '../constants';
import {isAndroid} from '../utils';
import Analytics from '../../../assets/components/analytics/Analytics';

export function trackShareLink(e, utmTerm, url) {

    let utmSource = e.target.parentElement.getAttribute('data-share-type');
    if (typeof window.utag !== "undefined") {

        if (typeof PARSELY !== "undefined" && typeof PARSELY.beacon === "object" && typeof PARSELY.beacon.trackPageView === 'function') {
            var utmObj = {
                'utm_campaign' : 'share_buttons',
                'utm_medium' : 'fscom',
                'utm_source' : 'share-' + utmSource,
                'utm_term': utmTerm,
                'utm_content' : 'original_share'
            };

            var trackObj = {
                'url': TrackingUtils.addTrackingQuery(utmObj, url),
                js: 1 // flag indicating that this is a dynamic event, keep it "1"
            };

            PARSELY.beacon.trackPageView(trackObj);
        }
    }
}

export function generateUtmTerm(utmTerm) {
    const pageMeta = Analytics.getPageMeta();
    const pageType = pageMeta ? pageMeta.page_type : 'post';
    return (utmTerm ? pageType + '_' + utmTerm : pageType).replace(/\s/g, '_');
}

export function generateShareLinks(title, url, utmTerm, utmParam) {
    utmParam = utmParam || 'utm_campaign=share_buttons&utm_medium=fscom&utm_content=return_visit';
    const encodedUrl = encodeURIComponent(url);
    const utmParams = `${utmParam}&utm_term=${utmTerm}`;
    const smsShare = encodedUrl + '?' + encodeURIComponent( utmParams + '&utm_source=share_sms');

    return {
        fb: shareLinks.FB_SHARE +  encodedUrl + '?' + utmParams + '&utm_source=share_fb',
        tw: shareLinks.TWITTER_SHARE +  encodedUrl + '?' + utmParams + '&utm_source=share_tw&&via=FoxSports&text=' + title,
        em: shareLinks.MAIL + encodeURIComponent('Read more @FOXSports - ' + title) + '&body=Read more @FOXSports - ' + title + ' - ' +  encodedUrl + '?' + encodeURIComponent( utmParams + '&utm_source=share_em'),
        whatsapp: 'whatsapp://send?text=' + encodedUrl + '?' +  encodeURIComponent( utmParams + '&utm_source=share_whatsapp'),
        sms: isAndroid ? 'sms:?body=' + encodeURIComponent( smsShare ) :  'sms:&body=' +  smsShare,
        cpyLink: url + '?' + utmParams + '&utm_source=share_url'
    }
}
